"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Report = function Report(_ref) {
  var title = _ref.title,
      description = _ref.description,
      width = _ref.width,
      height = _ref.height,
      rest = _objectWithoutProperties(_ref, ["title", "description", "width", "height"]);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    "aria-hidden": !title,
    "aria-labelledby": "ReportTitle ReportDescription",
    height: height,
    preserveAspectRatio: "none",
    role: "img",
    viewBox: "0 0 24 24",
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement("title", {
    id: "ReportTitle"
  }, title), /*#__PURE__*/_react["default"].createElement("desc", {
    id: "ReportDescription"
  }, description), /*#__PURE__*/_react["default"].createElement("path", {
    transform: "scale(1 1)",
    d: "M16.359 1.333c.203 0 .338.141.338.353v1.101h5.477c.205 0 .341.14.341.348v19.22c0 .173-.17.312-.34.312H2.006c-.204 0-.34-.14-.34-.347V3.135c0-.208.136-.347.34-.347H7.97V1.685c0-.212.135-.353.338-.353h8.05zm-8.39 2.148h-5.62v18.527H21.8V3.482h-5.103v1.413c0 .176-.17.317-.338.317H8.308c-.203 0-.338-.14-.338-.352V3.48zM19.017 16.5c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zM8.25 9.75v3.75H12a3.75 3.75 0 1 1-3.75-3.75zm10.766 4.5c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zm0-2.25c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zM9 9a3.75 3.75 0 0 1 3.75 3.75H9zm10.016.75c.29 0 .484.15.484.375s-.242.375-.484.375h-3.532c-.29 0-.484-.15-.484-.375s.194-.375.484-.375h3.532zM16.02 2.039H8.646v2.468h7.374V2.039z",
    fillRule: "evenodd"
  }));
};

Report.defaultProps = {
  description: '',
  height: 24,
  title: null,
  width: 24
};
Report.propTypes = {
  description: _propTypes["default"].string,
  height: _propTypes["default"].number,
  title: _propTypes["default"].string,
  width: _propTypes["default"].number
};
var _default = Report;
exports["default"] = _default;